import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { F } from 'nallian-shared-ui/lib/components';
import { compose } from 'redux';
import { useDebouncedCallback } from 'use-debounce';
import find from 'lodash/find';
import { GetOrganisationId } from 'nallian-shared-ui/lib/selectors';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import latinize from 'latinize';
import styled from 'styled-components';
import vehicleOwnersService from '../services/vehicleOwnersService';

const emptyArray = [];
const normalizeSearchInput = input =>
  input &&
  latinize(input)
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

const PaddedDiv = styled.div`
  margin: 1rem 0;
`;

const OwnerField = props => {
  const {
    input,
    t,
    dispatchVehicleOwnersGet,
    disabled,
    vehicleOwnersFetch,
    organisationId,
  } = props;

  const [debouncedDispatchVehicleOwners] = useDebouncedCallback(dispatchVehicleOwnersGet, 100);
  const [selectedValue, setSelectedValue] = useState(input.value.owner);
  const [searchQuery, setSearchQuery] = useState();
  const normalizedSearchQuery = normalizeSearchInput(searchQuery || input.value.owner);

  return (
    <Fragment>
      <F.Checkbox
        name="iAmOwner"
        toggle
        label={input.value.ownedById ? t('iAmTheOwner') : t('externalOwner')}
        checked={input.value.ownedById === organisationId}
        onChange={(e, data) =>
          input.onChange(
            data.checked
              ? { ownedById: organisationId, owner: undefined }
              : { owner: selectedValue, ownedById: undefined }
          )
        }
      />

      {input.value.ownedById !== organisationId && (
        <PaddedDiv>
          <F.Select
            hasLabel={false}
            name="owner"
            placeholder={t('owner')}
            disabled={disabled}
            fluid
            icon="search"
            loading={vehicleOwnersFetch.pending}
            search
            onSearchChange={(_, field) => {
              setSearchQuery(field.searchQuery);
              input.onChange({ owner: field.searchQuery, ownedById: undefined });
              if (field.searchQuery.length >= 2) {
                debouncedDispatchVehicleOwners(field.searchQuery[0] + field.searchQuery[1]);
              }
            }}
            options={(vehicleOwnersFetch.value || emptyArray)
              .concat([
                // add current value if not in array
                !vehicleOwnersFetch.value ||
                !find(
                  vehicleOwnersFetch.value,
                  vehicleOwner => normalizeSearchInput(vehicleOwner) === normalizedSearchQuery
                )
                  ? searchQuery || input.value.owner
                  : undefined,
              ])
              .filter(item => item)
              .map(item => ({
                key: item,
                value: item,
                text: item,
              }))}
            minCharacters={2}
            lazyLoad
            clearable
            value={selectedValue || input.value.owner}
            onChange={(_, field) => {
              setSelectedValue(field.value);
              input.onChange({ owner: field.value, ownedById: undefined });
            }}
            onAddItem={(_, field) => {
              setSelectedValue(field.value);
              input.onChange({ owner: field.value, ownedById: undefined });
            }}
          />
        </PaddedDiv>
      )}
    </Fragment>
  );
};

OwnerField.propTypes = {
  t: PropTypes.func.isRequired,
  dispatchVehicleOwnersGet: PropTypes.func.isRequired,
  vehicleOwnersFetch: PropTypes.object.isRequired,
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  organisationId: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

OwnerField.defaultProps = {
  disabled: false,
};

function mapStateToProps(state) {
  return {
    organisationId: GetOrganisationId(state),
  };
}

export default compose(
  withTranslation(),
  connect(mapStateToProps),
  vehicleOwnersService
)(OwnerField);
